import "./HotelRevenueManagementConsulting.module.css";
import Header from "@/reusable_sections/Header";
import RevenueManagementHero from "./sections/RevenueManagementHero";
import RevenueChallenges from "./sections/RevenueChallenges";
import ConsultingProcess from "./sections/ConsultingProcess";
import Strategicoutcomes from "./sections/Strategicoutcomes";
import Consultingfaq from "./sections/Consultingfaq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function HotelRevenueManagementConsultingPage() {
  return <div>
      <Header />
      <RevenueManagementHero />
      <RevenueChallenges />
      <ConsultingProcess />
      <Strategicoutcomes />
      <Consultingfaq />
      <Services />
      <Footer />
    </div>;
}